/* TODO Finish and implement interface into code for booking event
SUGGESTION: Under is a simple and quick draft of an interface for a booking season. 
This must be created in collaboration with the backend and be implemented 
in the code for booking of event. This needs to be impoved and just change if nessessary
*/

export interface BookingSeason {
  id: number;
  year: number;
  is_fall: boolean;

  semester_start: string;
  semester_end: string;

  booking_open: string;
  booking_end: string;

  unavailable_dates_collaboration_partner: string[];

  unavailable_date_kd_start: string;
  unavailable_date_kd_end: string;

  unavailable_date_ot_start: string;
  unavailable_date_ot_end: string;

  unavailable_dates_other: string[];

  booked_days: string[];
  is_open: boolean;

  price_model: string;
}

export const NO_AVAILABLE_SEASON = Symbol("NO_AVAILABLE_SEASON");

export type NoAvailableSeason = typeof NO_AVAILABLE_SEASON;

export const UNKNOWN_ERROR = Symbol("UNKNOWN_ERROR");

export type UnknownError = typeof UNKNOWN_ERROR;
